/** Sanity blocks hidden until removed in Studio (duplicate of split-image-text content). */
const hiddenSanityContentBlockKeys = new Set([
  '5d33b74aa969', // About: grape mission/vision richText
]);

export function isHiddenSanityContentBlock(key?: string | null) {
  return Boolean(key && hiddenSanityContentBlockKeys.has(key));
}

/** Rich text blocks where bodyLrg should render as standard body (one size down). */
const richTextBodyLargeAsBodyKeys = new Set([
  '34aeecf54f02', // About: The Kids Behind Babs
]);

export function getRichTextBodyLargeClassName(blockKey?: string | null) {
  return blockKey && richTextBodyLargeAsBodyKeys.has(blockKey) ? 'body' : 'body--large';
}

/** About page Kids Behind Babs carousel — fixed member order until Sanity is updated. */
const KIDS_BEHIND_BABS_CAROUSEL_KEY = 'd321da15f4a5';
const KIDS_BEHIND_BABS_ORDER = ['Aaron', 'Allison', 'Chloe', 'Harshith', 'Liz', 'Santi', 'Zhen'] as const;

type ImageTextCarouselBlock = {
  content?: Array<{
    _type?: string;
    style?: string;
    children?: Array<{ text?: string }>;
  }> | null;
  image?: {
    assetPath?: string | null;
    caption?: string | null;
  } | null;
  eyebrow?: string | null;
  heading?: string | null;
};

function getImageTextBlockName(block: ImageTextCarouselBlock): string {
  const heading = block.content?.find((entry) => entry._type === 'block' && entry.style === 'h3');
  return heading?.children?.[0]?.text?.trim() ?? '';
}

export function getOrderedImageTextCarouselBlocks<T extends ImageTextCarouselBlock>(
  carouselKey: string | undefined | null,
  blocks: T[] | undefined | null,
): T[] | undefined | null {
  if (!blocks || carouselKey !== KIDS_BEHIND_BABS_CAROUSEL_KEY) return blocks;

  const blocksByName = new Map(
    blocks.map((block) => [getImageTextBlockName(block), block] as const).filter(([name]) => name),
  );

  return KIDS_BEHIND_BABS_ORDER.map((name) => {
    const existing = blocksByName.get(name);
    if (existing) return existing;

    return {
      content: [{ _type: 'block', style: 'h3', children: [{ text: name }] }],
      image: { assetPath: null, caption: name },
    } as T;
  });
}
